import React from 'react';
import Menu from '../components/Menu';
import { useSelector, useDispatch } from 'react-redux';
import{ login, setOrgId, setApiKey, setDeviceId } from '../store/AuthStore';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const authState = useSelector((state) => state["authState"]); 

    const handleLogin = (e) => {
        e.preventDefault();
        dispatch(login()); 
        navigate('/');
    };

    const handleOrgIdChange = (e) => {
        dispatch(setOrgId(e.target.value)); 
    };

    const handleApiKeyChange = (e) => {
        dispatch(setApiKey(e.target.value)); 
    };
    const handleDeviceIdChange = (e) => {
        dispatch(setDeviceId(e.target.value)); 
    };

    return (
        <div className="App">
            <Menu />
            <div className="login">
                <h2>Indstil skærm</h2>
                <form onSubmit={handleLogin}>
                    <label>OrganizationId</label>
                    <input
                        type="text"
                        placeholder="Id"
                        value={authState.orgId}
                        onChange={handleOrgIdChange}
                    />
                    <label>ApiKey</label>
                    <input
                        type="password"
                        placeholder="Api-key"
                        value={authState.apiKey}
                        onChange={handleApiKeyChange}
                    />
                    <label>DeviceId</label>
                    <input
                        type="deviceId"
                        placeholder="Device-id"
                        value={authState.deviceId}
                        onChange={handleDeviceIdChange}
                    />
                    <input type="submit" className="btn" value="login" />
                </form>
            </div>
        </div>
    );
};

export default Login;